import {Component, Prop, h} from '@stencil/core';
import {RatingStarsSizes} from '@/types';

/**
 @slot rating-stars-slot - Generic slot to add some additional content that requires translations, not only numbers.
 */
@Component({
    tag: 'joy-rating-stars',
    styleUrl: 'rating-stars.scss',
    shadow: true,
})
export class RatingStars {
    /**
     * The actual rating, between 0 and 5.
     */
    @Prop({reflect: true}) ratingValue: number = 0;
    /**
     * Star size. 3 possible values but you can't give a number as value
     */
    @Prop({reflect: true}) size: RatingStarsSizes = 'medium';
    /**
     * Review count. it will be displayed with parenthesis : (5)
     */
    @Prop({reflect: true}) reviewCount: number = 0;

    private getFullStarSvg(): string {
        return `<joy-icon color="yellow" name="star-fill"></joy-icon>`;
    }

    private getHalfStarSvg(): string {
        return `<joy-icon color="yellow" name="star-half"></joy-icon>`;
    }

    private getEmptyStarSvg(): string {
        return `<joy-icon color="yellow" name="star"></joy-icon>`;
    }

    private setStars(rating: number): string {
        let icons = '';
        let on = 0.24;
        let half = 0.75;

        for (let i = 0; i < 5; i++) {
            let img = '';

            if (rating > on) {
                img = rating < half ? this.getHalfStarSvg() : this.getFullStarSvg();
            } else {
                img = this.getEmptyStarSvg();
            }

            icons += `<li class="joy-rating-stars--${this.size}">${img}</li>`;
            on += 1;
            half += 1;
        }

        return icons;
    }

    get starSize() {
        switch (this.size) {
            case 'large':
                return 17;
            case 'medium':
                return 14;
            case 'small':
                return 11;
            default:
                return 14;
        }
    }

    get ratingStarsWrapper() {
        return <ul class="joy-rating-stars" innerHTML={this.setStars(this.ratingValue)}></ul>;
    }

    get numberOfRateTextContent() {
        return this.reviewCount > 0 ? <span>({this.reviewCount})</span> : '';
    }

    render() {
        return (
            <div class="joy-rating-stars__wrapper">
                {this.ratingStarsWrapper}
                <slot name="rating-stars-slot">{this.numberOfRateTextContent}</slot>
            </div>
        );
    }
}
